const scrollTo = (_target, _margin, _speed, _callback) => {
  const margin = _margin || 0;
  const target = (_target instanceof jQuery) ? _target : $(_target);
  let position;
  if (target.prop('tagName') == 'BODY') {
    position = 0;
  }
  else {
    position = target.offset().top - margin;
  }
  $('html,body').animate({ scrollTop: position }, _speed || 500, 'easeOutQuart', _callback);
}

export default scrollTo